import React from "react";
import PropTypes from "prop-types";
import {useIntl} from "react-intl";
import {useHistory} from "react-router-dom";

import {Box, TableCell, TableRow} from "@mui/material";

import VariantBadge from "components/dashboard/VariantBadge";

import ProductDescription from "../../TopTablesComponents/ProductDescription";
import ProductImage from "../../TopTablesComponents/ProductImage";
import StatusPill from "./StatusPill";

import {
    black500,
    blue50,
    blue100,
    green50,
    green100,
    greyishBlue50,
} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {navigateOnClick} from "utils/navigateOnClick";

function ProductRow({ rank, product }) {
    const intl = useIntl();
    const { id, name, brand, image, sales = 0, stock = 0, status, variants = [], sku, retailerId } = product ?? {};

    const history = useHistory();

    return (
        <TableRow
            hover
            sx={{
                cursor: 'pointer',
                "td" : {padding: '20px 10px'},
                "td:last-of-type": { paddingRight: '20px' },
                "td:first-of-type": { paddingLeft: '20px' },
            }}
            onClick={(e) => navigateOnClick(e, MarketplaceRoutes.RETAILER_PRODUCT(retailerId, id), history)}
        >
            <TableCell sx={{ py: "20px", pl: "20px" }}>
                <ProductImage image={image} name={name} rank={rank} />
            </TableCell>

            <TableCell align="left" sx={{ fontSize: "14px", fontWeight: 600, color: black500 }}>
                {sales.toLocaleString()}
            </TableCell>

            <TableCell>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
                    <StatusPill bg={blue50} border={blue100} dotColor="#0944B5" textColor="#0944B5">
                        {intl.formatMessage({ id: "dashboard.productRank.table.stocks" }, { stock })}
                    </StatusPill>

                    {status ? (
                        <StatusPill bg={green50} border={green100} dotColor="#1B7055" textColor="#1B7055">
                            {intl.formatMessage({ id: "dashboard.productRank.table.status.actived" })}
                        </StatusPill>
                    ) : (
                        <StatusPill bg={greyishBlue50} border="#E0E0E5" dotColor="#9AA4B2" textColor="#6B7280">
                            {intl.formatMessage({ id: "dashboard.productRank.table.status.deactivated" })}
                        </StatusPill>
                    )}
                </Box>
            </TableCell>

            <TableCell>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                    {variants.map((v, i) => (
                        <VariantBadge key={i} value={v} />
                    ))}
                </Box>
            </TableCell>

            <TableCell sx={{ pr: "24px" }}>
                <ProductDescription
                    name={name}
                    brand={brand}
                    sku={sku}
                />
            </TableCell>
        </TableRow>
    );
}

ProductRow.propTypes = {
    rank: PropTypes.number.isRequired,
    product: PropTypes.shape({
        name: PropTypes.string,
        brand: PropTypes.string,
        image: PropTypes.string,
        sales: PropTypes.number,
        stock: PropTypes.number,
        status: PropTypes.bool,
        variants: PropTypes.arrayOf(PropTypes.string),
        sku: PropTypes.string,
    }),
};

export default ProductRow;
